<template>
    <div class="contact">
        <div class="contact-header">
            <img class="contact-header__image" src="/assets/imgs/contact-bg.png" alt="">

            <div class="contact-header__content-container">
                <div class="contact-header__content-wrapper">
                    <h2 class="contact-header__heading">BE A HUNTER</h2>
                    <p class="contact-header__paragraph">We’re always on the hunt for the greatest talent to join our team, from interns to SVPs.</p>
                    <router-link class="contact-header__email" to="/contact/be-a-hunter">Be a Hunter</router-link>
                </div>

                <div class="contact-header__content-wrapper">
                    <h2 class="contact-header__heading">HIRE US</h2>
                    <p class="contact-header__paragraph">To learn more about HUNTER's solutions, Contact Samara Farber Mormar</p>
                    <button class="contact-header__email" onClick="window.location.href='mailto:smormar@hunterpr.com'">smormar@hunterpr.com</button>
                </div>
            </div>
        </div>
            
        <div class="contact-body">
            <router-link class="contact-body__scroll-link" to="/news">
                <img class="contact-body__scroll-image" src="/assets/imgs/scroll-left.png" alt="">
            </router-link>

            <div class="contact-body__container">
                <h2 class="contact-body__heading">INQUIRIES</h2>

                <ul class="contact-body__list">              
                    <li class="contact-body__list-item">
                        <h3 class="contact-body__sub-heading">MEDIA</h3>

                        <p class="contact-body__paragraph">To receive regular updates on Hunter client news, contact:</p>

                        <a class="contact-body__link" href="mailto:media@hunterpr.com" target="_blank">media@hunterpr.com</a>
                    </li>
                        
                    <li class="contact-body__list-item">
                        <h3 class="contact-body__sub-heading">INFLUENCERS</h3>

                        <p class="contact-body__paragraph">Interested in <a href='/expertise/solutions/partnerships'>partnering</a>? Contact:</p>

                        <a class="contact-body__link" href="mailto:influence@hunterpr.com" target="_blank">influence@hunterpr.com</a>
                    </li>
                </ul>
            </div>

            <div class="contact-body__container"> 
                <h2 class="contact-body__heading">OFFICES</h2>

                <ul class="contact-body__list">
                    <li class="contact-body__list-item--offices">
                        <div class="contact-body__office-details">
                            <h3 class="contact-body__sub-heading">NEW YORK</h3>

                            <address class="contact-body__office-details-address">
                              One World Trade Center<br>
                                Floor 68<br>
                            New York, NY 10007</address>
                            <h4 class="contact-body__office-details-sub-heading">Email</h4>

                            <a class="contact-body__office-details-email" href="mailto:hi@hunterpr.com" target="_blank">Hi@hunterpr.com</a>
                            
                            <h4 class="contact-body__office-details-sub-heading">Telephone</h4>

                            <p class="contact-body__office-details-telephone">212.679.6600</p>

                            <h4 class="contact-body__office-details-sub-heading">Fax</h4>
                            
                            <p class="contact-body__office-details-telephone">212.679.6607</p>

                            <a class="contact-body__link--directions" href="https://www.google.com/maps/place/One+World+Trade+Center/@40.7122018,-74.0144752,18z/data=!4m5!3m4!1s0x89c25a197c06b7cb:0x40a06c78f79e5de6!8m2!3d40.7127431!4d-74.0133795" target="_blank">Get directions</a>   
                        </div>

                        <div class="contact-body__office-map">
                            <a class="contact-body__office-map-link" href="https://www.google.com/maps/place/One+World+Trade+Center/@40.7122018,-74.0144752,18z/data=!4m5!3m4!1s0x89c25a197c06b7cb:0x40a06c78f79e5de6!8m2!3d40.7127431!4d-74.0133795" target="_blank">
                                <img class="contact-body__office-map-image" src="/assets/imgs/map-new-york.jpg" alt="New York Office Map">
                            </a>
                        </div>
                    </li>

                    <li class="contact-body__list-item--offices">
                        <div class="contact-body__office-details">
                            <h3 class="contact-body__sub-heading">LONDON</h3>

                            <address class="contact-body__office-details-address">
                              Blue Fin Building<br/>Third Floor 110 Southwark Street<br/>
                              London, SE1 0SU<br/>
                            </address>

                            <h4 class="contact-body__office-details-sub-heading">Email</h4>
                            <a class="contact-body__office-details-email" href="mailto:info@hunterpr.co.uk" target="_blank">info@hunterpr.co.uk</a>
                        
                            <h4 class="contact-body__office-details-sub-heading">Telephone</h4>
                            <p class="contact-body__office-details-telephone">+44 20 4570 4315</p>

                            
                            <a class="contact-body__link--directions" href="https://maps.app.goo.gl/5wRB79EZbQdvcHbB9" target="_blank">Get directions</a>   
                        </div>

                        <div class="contact-body__office-map">
                            <a class="contact-body__office-map-link" href="https://maps.app.goo.gl/5wRB79EZbQdvcHbB9" target="_blank">
                                <img class="contact-body__office-map-image" src="/assets/imgs/map-london.jpg" alt="London Office Map">
                            </a>
                        </div>
                    </li>     

		            <li class="contact-body__list-item--offices">
                        <div class="contact-body__office-details">
                            &nbsp;<br/><h3 class="contact-body__sub-heading">LOS ANGELES</h3>

                            <address class="contact-body__office-details-address" style="white-space: nowrap;">
                              The Lot At Formosa<br/>1041 N. Formosa Avenue<br/> FWB STE 500<br/>West Hollywood, CA 90046</address>

                            <h4 class="contact-body__office-details-sub-heading">Email</h4>

                            <a class="contact-body__office-details-email" href="mailto:LAinfo@hunterpr.com" target="_blank">LAinfo@hunterpr.com</a>
                            
                            <a class="contact-body__link--directions" href="https://goo.gl/maps/V88P7MQ9VDpwfqcF9" target="_blank">Get directions</a>   
                        </div>

                        <div class="contact-body__office-map">
                            &nbsp;<br/><a class="contact-body__office-map-link" href="https://goo.gl/maps/V88P7MQ9VDpwfqcF9" target="_blank">
                                <img class="contact-body__office-map-image" src="/assets/imgs/map-la.jpg" alt="LA Office Map">
                            </a>
                        </div>
                    </li>         

                    <li class="contact-body__list-item--offices">
                        <div class="contact-body__office-details">
                            &nbsp;<br/><h3 class="contact-body__sub-heading">CHICAGO</h3>

                            <address class="contact-body__office-details-address">
                              225 W Wacker Drive<br/>Floor 19<br/>Chicago, IL 60606</address>

                            <h4 class="contact-body__office-details-sub-heading">Email</h4>

                            <a class="contact-body__office-details-email" href="mailto:CHIinfo@hunterpr.com " target="_blank">CHIinfo@hunterpr.com</a>
                            
                            <a class="contact-body__link--directions" href="https://maps.app.goo.gl/iXpwMGQcaFibv2gH8" target="_blank">Get directions</a>   
                        </div>

                        <div class="contact-body__office-map">
                            &nbsp;<br/><a class="contact-body__office-map-link" href="https://goo.gl/maps/V88P7MQ9VDpwfqcF9" target="_blank">
                                <img class="contact-body__office-map-image" src="/assets/imgs/map-chicago.jpg" alt="Chicago Office Map">
                            </a>
                        </div>
                    </li>        

                    <li class="contact-body__list-item--offices">
                        <div class="contact-body__office-details">
                            &nbsp;<br/><h3 class="contact-body__sub-heading">TORONTO</h3>

                            <address class="contact-body__office-details-address">
                              351 King St E<br>Suite 600<br/>Toronto, Ontario <br>M5A 0L6, Canada</address>

                            <h4 class="contact-body__office-details-sub-heading">Email</h4>

                            <a class="contact-body__office-details-email" href="mailto:hi@hunterpr.com " target="_blank">hi@hunterpr.com</a>
                            
                            <a class="contact-body__link--directions" href="https://maps.app.goo.gl/Mp2q2ErM2VhHznr98" target="_blank">Get directions</a>   
                        </div>

                        <div class="contact-body__office-map">
                            &nbsp;<br/><a class="contact-body__office-map-link" href="https://maps.app.goo.gl/Mp2q2ErM2VhHznr98" target="_blank">
                                <img class="contact-body__office-map-image" src="/assets/imgs/map-chicago.jpg" alt="Toronto Office Map">
                            </a>
                        </div>
                    </li>       
                </ul>
            </div>

            <div class="contact-body__container">
                <h2 class="contact-body__heading">Follow Us</h2>
                <ul class="contact-body__social-list">
                    <li class="contact-body__social-item">
                        <a class="contact-body__social-link" href="https://www.facebook.com/HunterPR" target="_blank">
                            <img class="contact-body__social-image" src="/assets/imgs/social-facebook.png" alt="Facebook">
                        </a>
                    </li>

                    <li class="contact-body__social-item">
                        <a class="contact-body__social-link" href="https://www.instagram.com/hunterprny/" target="_blank">
                            <img class="contact-body__social-image" src="/assets/imgs/social-instagram.png" alt="Instagram">
                        </a>
                    </li>

                  <li class="contact-body__social-item">
                    <a class="contact-body__social-link" href="https://www.linkedin.com/company/hunterny/" target="_blank">
                      <img class="contact-body__social-image" src="/assets/imgs/social-linkedin.png" alt="Twitter">
                    </a>
                  </li>
                </ul>
            </div>
        </div>
  
        <div class="contact-body-footer">
            <h2 class="contact-body-footer__heading">Learn more...</h2>
            <div class="contact-body-footer__link-container">
                <router-link to="/work/case-studies" class="contact-body-footer__link">Work</router-link>
                <router-link to="/expertise/explore" class="contact-body-footer__link">Expertise</router-link>
            </div>
        </div>
    </div> 
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .clearfix {
        zoom:1;
        &:before, &:after{ content:""; display:table; }
        &:after{ clear: both; }
    }

    .contact {
        background-color: #003a4a;
        overflow-x: hidden; 
        position:relative;
        padding: 140px 0 0 0; 
        width: 100%;
    }

    .contact-body__container {
        box-sizing: border-box;
        opacity: 0;
        margin: 0 0 80px 50px;
        max-width: 1300px;
        padding: 0 50px;
        position: relative;
        transform: translateX(100px);
        z-index: 0;

        @media @breakpoint__tablet--large {
            margin: 0 auto 80px;
        }

        @media @breakpoint__mobile--large {
            margin: 0 auto 40px;
            padding: 0 25px;
        }

        @media @breakpoint__mobile--large {
            margin: 0 auto 40px;
            padding: 0 25px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .contact-side-nav__container {
        position: absolute;
        text-align: right;
        top: 50vh;
        transform: translate(0, -50%);

        .contact-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 36px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 2px;
            text-transform: uppercase;
        }

        .contactk-side-nav__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .contact-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 3px;
                display: inline-block;
                height: 6px;
                margin: 0 3px;
                width: 6px;
                z-index: 1;

                &.active {
                    background: #e40046;
                }
            }
        }
    }

    .contact-side-nav__container--left {
        .contact-side-nav__container();
        left: 10px;
        text-align: left;

        .work-side-nav__image {
            display: block;
            margin-top: 10px;
        }
    }

    .contact-header {
        box-sizing: border-box;
        margin: 0 0 30px 50px;
        max-width: 1300px;
        overflow: hidden;
        padding: 0px 100px 0 50px;
        position: relative;
        width: 100%;

        @media @breakpoint__tablet--large {
            margin: 0 auto 30px;
            padding: 0px 50px;
        }

        @media @breakpoint__mobile--large {
            padding: 0 25px;
        }
    }

    .contact-header__image {
        box-sizing: border-box;
        display: inline-block;
        padding-right: 8%;
        opacity: 0;
        position: relative;
        transform: translateX(200px);
        width: 30%;
        z-index: 0;

        @media @breakpoint__tablet--medium {
            margin-bottom: 50px;
            width: 40%;
        }

        @media @breakpoint__mobile--large {
            width: 80%;
        }
    }

    .contact-header__content-container {
        display: inline-block;
        margin-bottom: 80px;
        opacity: 0;
        position: relative;
        vertical-align: top;
        width: 70%;
        z-index: 10;

        @media @breakpoint__tablet--medium {
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            margin-bottom: 0;
        }
    }

    .contact-header__content-wrapper {
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        vertical-align: top;
        width: 50%;

        &:first-child {
            padding-right: 40px;
        }

        @media @breakpoint__tablet--medium {
            margin-bottom: 50px;
            padding: 0 !important;
            width: 100%;
        }
    }

    .contact-header__heading {
        color: #ffffff;
        margin: 0 0 15px 0;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        line-height: 1;
    }

    .contact-header__paragraph {
        color: #fff;
        letter-spacing: 1px;
        line-height: 1.8em;
        margin: 0 0 20px;
    }

    .contact-header__email {
        border: none;
        border-radius: 5px;
        background: #e40046;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        min-width: 130px;
        outline: none;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;
    }

    .contact-body__social-list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .contact-body__social-item {
        display: inline-block;
        margin-right: 50px;

        @media @breakpoint__mobile--small {
            margin-right: 0;
            width: calc(~"100% / 3");
        }
    }

    .contact-body {
        background: #fff;
        border-top-right-radius: 150px;
        border-bottom-right-radius: 150px;
        padding: 100px 0;
        position: relative;
        max-width: 1500px;
        width: 100%;

        @media @breakpoint__tablet--small {
            border-top-right-radius: 50px;
            border-bottom-right-radius: 50px;
            padding: 60px 0;
        }
    }

    .contact-body__scroll-link {
        display: inline-block;
        left: 10px;
        position: absolute;
        opacity: 0;
        top: 110px;
        z-index: 100;
        
        @media @breakpoint__tablet--large {
            display: none;
        }
    }

    .contact-body__scroll-image {
        display: block;
    }

    .contact-body__heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 1px;
        margin: 0 0 25px 0;
        text-transform: uppercase;
    }

    .contact-body__list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .contact-body__list-item {
        display: inline-block;
        padding: 0 12% 0 0;
        width: 280px;    
        vertical-align: top;

        @media @breakpoint__tablet--medium {
            box-sizing: border-box;
            width: 50%;
        }

        @media @breakpoint__mobile--large {
            display: block;
            margin-bottom: 40px;
            padding: 0;
            width: 100%;
        }

        &:last-child {
            padding: 0;
        }
    }

    .contact-body__sub-heading {
        color: #e40046;
        font-size: 22px;
        font-weight: 400;
        letter-spacing: 1px;
        margin: 0 0 20px 0;
    }

    .contact-body__paragraph {
        color: #003a4a;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.8em;
        margin: 0 0 10px;
    }

    .contact-body__link {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        text-decoration: none;
        transition: color 0.5s;

        &:hover {
            color: #e40046;
        }
    }

    .contact-body__list-item--offices {
        .contact-body__list-item();
        display: inline-flex;
        padding: 0;
        width: 50%;

        @media @breakpoint__tablet--large {
            margin-bottom: 60px;
            width: 100%;
        }
    }

    .contact-body__office-details {
        display: inline-block;
        width: 200px;

        @media @breakpoint__tablet--medium {
            width: 40%;
        }

        @media @breakpoint__mobile--large {
            margin-bottom: 30px;
            width: 100%;
        }
    }

    .contact-body__office-details-sub-heading {
        color: #003a4a;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-weight: 400;
        margin: 0 0 3px;
        text-transform: uppercase;
    }

    .contact-body__office-details-telephone {
        color: #003a4a;
        margin:0 0 15px;
    }

    .contact-body__office-details-email {
        .contact-body__link();
        display:block;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-weight: 400;
        margin:0 0 15px;
    }

    .contact-body__office-details-address {
        .contact-body__paragraph();
        font-style: normal;
        line-height: 1.4;
        margin-bottom: 15px;
    }

    .contact-body__office-map {
        box-sizing: border-box;
        display: inline-block;
        flex: 1;
        padding: 0 10% 0 5%;
        position: relative;
        vertical-align: top;

        @media @breakpoint__tablet--large {
            padding: 0 0 0 5%;
            width: 60%;
        }

        @media @breakpoint__mobile--large {
            padding: 0;
            width: 100%;
        }
    }

    .contact-body__office-map-link {
        display: block;
    }
   
    .contact-body__office-map-image {
        border-radius: 45px;
        max-width: 425px;
        width: 100%;
    }

    .contact-body__link--directions {
        .contact-body__link();
        color: #e40046;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 18px;
        text-decoration: underline;
    }

    .contact-body-footer {
        background: #003a4a;
        padding: 60px 20px;
    }

    .contact-body-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 1px;
        line-height: 1;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .contact-body-footer__link-container {
        display: block;
        text-align: center;
    }

    .contact-body-footer__link {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        min-width: 110px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>

<script>
    export default {
        name: "Contact",
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initAnimIn();
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initAnimIn : function()
            {
                var tl = new TimelineMax();
                tl.to(".contact-header__image", 0.8, {transform: "translateX(0)", opacity: 1, ease: Power2.easeOut});
                tl.to(".contact-header__content-container", 0.8, {transform: "translateX(0)", opacity: 1}, "-=0.6");
                tl.staggerTo(".contact-body__container", 0.6, {transform: "translateX(0)", opacity: 1}, 0.2, "-=0.4");
                tl.to(".contact-body__scroll-link", 0.5, {opacity: 1}, "-=0.4");
                document.querySelector(".header__logo-sub-title").innerHTML = "Contact";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            beforeEnterSideNavLeft :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft : function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 2});
            }
        }
    };
</script>
